<template>
  <div class="pa-md-4 pa-3">
    <div class="display-1 font-weight-bold pb-4">
      {{ `Подключить тариф: ${tariff.name}?` }}
    </div>
    <v-flex v-for="func in tariff.functions" :key="func.id">
      <div class="d-flex subtitle-1 pb-3">
        <div class="flex-none">{{ func.name }}</div>
        <div class="mx-2 dashed"></div>
        <div class="flex-none">{{ `${func.abonpay} ₽/мес` }}</div>
      </div>
    </v-flex>
    <div class="d-flex pt-2 mt-4 ">
      <v-btn @click="sendToChange" class="primary mx-0">
        Оставить заявку менеджеру
      </v-btn>
      <div class="valign-middle text-sm-right align-self-center ml-3">
        <button
          @click="cancel"
          type="button"
          class="subtitle-1 font-weight-medium"
          v-if="!['xs'].includes($vuetify.breakpoint.name)"
        >
          <span class="dashed dashed--2">
            Отменить
          </span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import RequestApi from "../../modules/requestApi";

export default {
  name: "tariffChangeConfirm",
  props: {
    tarif_id: {
      type: String,
      required: true
    },
    service_id: {
      type: Number,
      required: true
    }
  },
  computed: {
    tariff() {
      if (!this.tarif_id) return { name: "", functions: [] };
      return this.$store.getters.tariffList.find(
        item => item.id === this.tarif_id
      );
    }
  },
  beforeMount() {
    this.tariff.functions.push({
      name: "Абонентская плата",
      abonpay: this.tariff.price
    });
  },
  methods: {
    // отмена
    cancel() {
      this.$emit("cancel");
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    sendToChange() {
      const tarif_descr =
        `${this.tariff.name} ${this.tariff.smsCount}` +
        ` стоимостью ${this.tariff.price}`;
      RequestApi.sendToChangeTariff({
        tarifId: this.tarif_id,
        tarifDescr: tarif_descr,
        serviceId: this.service_id
      })
        .then(() => {
          // открываем сообщение
          this.$store
            .dispatch("popupInfoOpen", {
              timeout: 3000,
              text: "Заявка успешно отправлена"
            })
            .then(() => {
              this.$emit("closeDialog");
            });
        })
        .catch(err => {
          this.error = err;
        });
    }
  }
};
</script>
